module.exports = __webpack_public_path__ + "img/book.1c79a6a9.svg";